import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class WysiwygService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Wake up WYSIWYG
     * @returns any Job is starting.
     * @throws ApiError
     */
    wysiwygWakeUps({ search, cookie, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/wysiwyg/wake-ups', headers: {
                'cookie': cookie,
            }, query: {
                'search': search,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                409: `Conflict.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get project WYSIWYG
     * @returns Wysiwyg OK.
     * @throws ApiError
     */
    getWysiwyg({ orgId, projectId, branchName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/projects/{projectId}/wysiwyg/branch/{branchName}', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Stop WYSIWYG job
     * @returns void
     * @throws ApiError
     */
    stopWysiwyg({ orgId, projectId, branchName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/wysiwyg/branch/{branchName}/stop', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Restart WYSIWYG job
     * @returns void
     * @throws ApiError
     */
    restartWysiwyg({ orgId, projectId, branchName, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'PUT', url: '/orgs/{orgId}/projects/{projectId}/wysiwyg/branch/{branchName}/restart', path: {
                'orgId': orgId,
                'projectId': projectId,
                'branchName': branchName,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                404: `Resource not found.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=WysiwygService.js.map